import { atom } from 'jotai'
import * as coreAtoms from 'src/v2/state/core'

export const selectedEntityId = atom<Promise<string | undefined>>(async (get) => {
  const selectedEntity = await get(coreAtoms.selectedEntity)
  if (!selectedEntity || selectedEntity.type !== 'SELECTED_OWNER') {
    return undefined
  }
  return selectedEntity.data.id
})

export const selectedParcelId = atom<Promise<string | undefined>>(async (get) => {
  const selectedEntity = await get(coreAtoms.selectedEntity)
  if (!selectedEntity || selectedEntity.type !== 'SELECTED_PARCEL') {
    return undefined
  }
  return selectedEntity.data.id
})

export const selectedEntityOrParcelId = atom<Promise<string | undefined>>(async (get) => {
  const entityId = await get(selectedEntityId)
  if (entityId) {
    return entityId
  }

  const parcelId = await get(selectedParcelId)
  if (parcelId) {
    return parcelId
  }

  return undefined
})

export const isEntityOrParcelSelected = atom(async (get) => !!(await get(selectedEntityOrParcelId)))

type NavigationHistory = {
  type: 'parcel' | 'entity'
  id: string
}
export const navigationHistory = atom<NavigationHistory[]>([])
